export class MtlsCertificate {
  certificate_id!: string;
  contract_id!: string;
  description!: string;
  hosts!: Array<{ host: string; host_id: string }>;
  status!: string;
  expiration_date!: string;

  constructor(mtlsCertificate: Partial<MtlsCertificate>) {
    Object.assign(this, mtlsCertificate);
  }
}
